const uk = {
    "front.faq.chat.title": "ПОСТАВИТИ ЗАПИТАННЯ",
    "front.faq.chat.description": "миттєва підтримка для гостей ресторану",
    "front.faq.chat.welcome": "Тут ви можете поставити запитання напряму.",
    "front.faq.chat.placeholder": "повідомлення",
    "front.faq.chat.send": "надіслати",
    "front.faq.chat.unsupportedLanguage": "Вибачте, наразі цей чат підтримує лише англійську та німецьку мови.",
    "front.faq.chat.fallback": "Дякуємо за повідомлення. Наразі я можу відповідати лише на поширені запитання. Будь ласка, зв’яжіться з нами напряму для додаткової інформації.",
    "front.faq.chat.answer.hours": "Ми відкриті щодня з 10:00 до 22:00.",
    "front.faq.chat.answer.reservation": "Так, ви можете забронювати столик прямо на нашому сайті або телефоном.",
    "front.faq.chat.answer.groupReservation": "Для групових бронювань, будь ласка, зв’яжіться з нами напряму, щоб ми підібрали найкращий варіант.",
    "front.faq.chat.answer.address": "Наша адреса: Musterstraße 1, Berlin.",
    "front.faq.chat.answer.parking": "Так, поруч є місця для паркування.",
    "front.faq.chat.answer.phone": "Ви можете зв’язатися з нами за номером +49 000 000000.",
    "front.faq.chat.answer.payment": "Так, у нас можна оплатити готівкою або карткою.",
    "front.faq.chat.answer.menu": "Актуальне меню доступне на сайті. Якщо у вас є запитання щодо окремих страв, ми із задоволенням допоможемо.",
    "front.faq.chat.answer.vegetarian": "Так, у нас є вегетаріанські страви.",
    "front.faq.chat.answer.vegan": "Так, у нашому меню також є веганські варіанти.",
    "front.faq.chat.answer.allergens": "Якщо у вас є алергії або непереносимості, будь ласка, зверніться до нас напряму. Ми надамо інформацію про інгредієнти.",
    "front.faq.chat.answer.takeaway": "Так, їжу також можна замовити з собою.",
    "front.faq.chat.answer.delivery": "Наразі через сайт доступні лише бронювання та запитання.",
    "front.faq.chat.answer.terrace": "Так, у гарну погоду ви також можете сидіти на нашій терасі.",
    "front.faq.chat.answer.pets": "Будь ласка, зв’яжіться з нами напряму, якщо хочете прийти з домашнім улюбленцем.",
    "front.faq.chat.answer.children": "Так, сім’ї з дітьми дуже бажані у нас.",
    "front.faq.chat.answer.wifi": "Так, для гостей доступний Wi-Fi.",


    "front.acquaintance.callback.placeholder": "Ваш номер телефону",
    "front.acquaintance.callback.send": "Надіслати",
    "front.acquaintance.callback.sending": "Надсилається...",
    "front.acquaintance.callback.invalidPhone": "Будь ласка, введіть коректний номер телефону.",
    "front.acquaintance.callback.success": "Запит надіслано. Я скоро з вами зв’яжуся.",
    "front.acquaintance.callback.error": "Помилка під час надсилання запиту. Спробуйте ще раз.",

    "front.landingSeo.links.digitalMenu": "Цифрове меню для ресторанів",
    "front.landingSeo.links.qrMenu": "QR-меню для ресторанів",
    "front.landingSeo.links.multilingualMenu": "Багатомовне меню для ресторанів",
    "front.landingSeo.links.reservation": "Онлайн-бронювання столиків для ресторанів",
    "front.landingSeo.links.freeDigitalMenu": "Спробувати безкоштовне цифрове меню",
    "front.landingSeo.links.changeMenuOnline": "Змінювати меню онлайн",

    "menu.title": "Меню",
    "menu.promo": "Спеціальні пропозиції",
    "menu.empty.categoryTitle": "Заповніть назву категорії",
    "menu.empty.itemTitle": "Заповніть назву товару",
    "menu.empty.itemDescription": "Заповніть опис товару",
    "cart.add": "Додати в кошик",
    "cart.cancel": "Скасувати",
    "section.video": "Відеопрезентація",
    "section.tables": "ОНЛАЙН-БРОНЮВАННЯ СТОЛІВ",
    "section.table": "ОБЕРІТЬ СТІЛ",
    "section.menu": "Меню ресторану",
    "section.faq": "Запитання та відповіді",
    "section.contact": "Контакти",
    "promo.buy": "Купити",

    "front.tenant.resolving": "Визначаємо ресторан за субдоменом…",
    "front.tenant.notFound": "Клієнта для цього субдомену не знайдено",
    "front.tenant.resolveError": "Не вдалося визначити клієнта",
    "front.menu.loading": "Завантаження…",
    "front.menu.loadError": "Не вдалося завантажити меню",
    "front.menu.addtocart": "Кошик",
    "front.menu.cancel": "Скасувати",
    "front.Number.servings": "Кількість порцій",

    "orbit.menu": "МЕНЮ",
    "orbit.shef": "БРОНЮВАННЯ",
    "orbit.video": "ВІДЕО",
    "orbit.faq": "ПИТАННЯ",
    "orbit.interior": "ІНТЕР’ЄР",
    "orbit.footer": "СОЦМЕРЕЖІ",

    "shef.title.line1": "ОНЛАЙН",
    "shef.title.line2": "БРОНЮВАННЯ",
    "shef.banner.label": "Оберіть",
    "shef.banner.main": "свій стіл",
    "shef.reserved": "ЗАБРОНЬОВАНО",

    "video.title": "ОСЬ ЯК МИ ГОТУЄМО — ЧЕСНО І СМАЧНО",
    "video.add": "Додати відео",
    "add.video.but": "Додати",

    "interior.title": "НАШ ІНТЕР’ЄР",

    "footer.kontact": "КОНТАКТИ",

    "telegram.title": "Щоб налаштувати Telegram-сповіщення про замовлення, потрібно:",
    "telegram.title.first": "1. Отримати BOT_TOKEN",
    "telegram.text.first": "Щоб отримати BOT_TOKEN, знайдіть і запустіть бота @BotFather у Telegram, надішліть команду /newbot, виконайте інструкції для створення унікальної назви та username бота, а потім скопіюйте API-токен, який @BotFather надішле у відповіді.",
    "telegram.title.two": "2. Отримати CHAT_ID",
    "telegram.text.two": "Щоб отримати CHAT_ID, знайдіть і запустіть бота @UserInfoBot у Telegram, надішліть команду /start і скопіюйте ID з повідомлення у відповіді.",

    "cart.title": "ВАШ КОШИК",
    "cart.header.aria": "Ваш кошик",
    "cart.toggle.expand": "Розгорнути кошик",
    "cart.toggle.collapse": "Згорнути кошик",
    "cart.total.label": "Разом",
    "cart.total.products": "товари",
    "cart.button.primary": "замовити",
    "cart.button.back": "назад",
    "cart.button.waiter": "ОФІЦІАНТ",
    "cart.mode.takeaway": "з собою",
    "cart.mode.tableTime": "Час і стіл",
    "cart.mode.tableTime.disabled": "немає вільних столів",
    "cart.mode.tableTime.tooltip": "Час і стіл",
    "cart.mode.tableTime.tooltipNoFree": "немає вільних столів",
    "cart.mode.inHouse": "у закладі",
    "cart.bookingFlow.title": "БРОНЮВАННЯ. НОМЕР СТОЛУ",
    "cart.deposit.itemTitle": "Бронювання столу (депозит)",
    "cart.deposit.lineTitle": "Депозит",
    "cart.deposit.badge": "Депозит {amount}€",
    "cart.table.msg.tempChosen": "Стіл {table} попередньо обрано ✓",
    "cart.table.msg.noFree": "На жаль, вільних столів немає",
    "cart.table.msg.chooseOrDefault": "Будь ласка, оберіть стіл або залиште вибір за замовчуванням.",
    "cart.table.select.reserved": "ЗАБРОНЬОВАНО",
    "cart.table.select.pick": "ОБРАТИ",
    "cart.table.select.any": "БУДЬ-ЯКИЙ",
    "cart.inHouse.title": "ОБЕРІТЬ НОМЕР СТОЛУ",
    "cart.inHouse.select.placeholder": "Оберіть стіл",
    "cart.inHouse.select.option": "Стіл #{n}",
    "cart.checkout.back": "Назад",
    "cart.payment.preparing": "Підготовка платежу…",
    "cart.loading": "Завантаження…",

    "mockCheckout.title.paymentMethod": "СПОСІБ ОПЛАТИ",
    "mockCheckout.method.card": "Банківська картка",
    "mockCheckout.method.paypal": "PayPal",
    "mockCheckout.method.gpay": "Google Pay",
    "mockCheckout.cardForm.title": "ВВЕДІТЬ ДАНІ КАРТКИ",
    "mockCheckout.cardForm.numberLabel": "НОМЕР КАРТКИ",
    "mockCheckout.error.invalidCardNumber": "Невірний номер картки",
    "mockCheckout.error.enter16Digits": "Введіть 16 цифр",
    "mockCheckout.error.expiryFormat": "Формат MM/YY",
    "mockCheckout.error.expiryMonthRange": "Місяць 01–12",
    "mockCheckout.error.cardExpired": "Термін дії картки минув",
    "mockCheckout.error.cvc3Digits": "3 цифри",
    "mockCheckout.error.sendTelegram": "Помилка надсилання в Telegram",
    "mockCheckout.error.generic": "Щось пішло не так",
    "mockCheckout.reserve.clientNotFound": "Клієнта не знайдено",
    "mockCheckout.reserve.tablesNotFound": "У клієнта немає секції столів",
    "mockCheckout.reserve.tableNotFound": "Стіл не знайдено",
    "mockCheckout.reserve.alreadyReserved": "Цей стіл щойно зайняли. Будь ласка, оберіть інший.",
    "mockCheckout.reserve.noFreeTables": "Зараз немає вільних столів",
    "mockCheckout.reserve.tableNotSelected": "Будь ласка, оберіть стіл",
    "mockCheckout.reserve.genericError": "Помилка бронювання",
    "mockCheckout.button.back": "назад",
    "mockCheckout.button.pay": "ОПЛАТИТИ",
    "mockCheckout.button.sending": "…надсилання",
    "mockCheckout.button.paid": "...",
    "mockCheckout.button.payInvalidTitle": "Будь ласка, перевірте дані картки",

    "admin.booking.lead.title": "МІНІМАЛЬНИЙ ЧАС ДО БРОНЮВАННЯ",
    "admin.booking.lead.note": "Це стосується лише гостьових бронювань у режимі «стіл і час». Крок — 30 хвилин.",

    "dateTimeStep.select.time": "ОБЕРІТЬ ЧАС",

    "admin.title": "АДМІН-ПАНЕЛЬ",
    "admin.loading": "Завантаження…",
    "admin.nav.delete": "Видалити",
    "admin.nav.back": "Назад",
    "admin.nav.next": "ДАЛІ",
    "admin.nav.confirm": "ЗБЕРЕГТИ",
    "admin.nav.confirm.now": "збереження ...",
    "admin.booking.settings": "Налаштування бронювання",
    "admin.booking.deposit": "СУМА ДЕПОЗИТУ",
    "admin.booking.deposit.note": "Депозит списується, коли гість бронює лише стіл",

    "admin.hub.editmenu": "РЕДАГУВАТИ МЕНЮ",
    "admin.hub.qr": "QR-КОД",
    "admin.hub.prices": "ВАШ ТАРИФ",
    "admin.hub.settings": "НАЛАШТУВАННЯ",

    "admin.panel.editmenu": "Редагування меню",
    "admin.validation.required": "Обов’язкове поле",
    "admin.panel.add": "Додати позицію",
    "admin.panel.menu": "Редагувати список меню",
    "admin.panel.telegram": "Telegram",
    "admin.panel.table": "КЕРУВАННЯ СТОЛАМИ",
    "admin.set.table": "Зали / столи",
    "admin.set.logo": "Логотип і фони",
    "admin.logo.successfully.applied": "Логотип успішно застосовано",
    "admin.logo.download.error": "Помилка завантаження",
    "admin.settings.number.rooms": "Кількість залів",
    "admin.settings.room": "Зал",

    "admin.qr.title": "QR-код для гостей",
    "admin.qr.alt": "QR для ресторану",
    "admin.qr.copy": "копіювати посилання",
    "admin.qr.copied": "✓ скопійовано",
    "admin.qr.note": "Гості можуть відсканувати цей код, щоб миттєво відкрити вашу сторінку.",

    "admin.link.notfound": "Посилання не знайдено",
    "admin.table.info": "Керування столами доступне на цій сторінці. Статус змінюється натисканням.",
    "admin.prices.temp": "Ціни тимчасово недоступні.",
    "admin.forgot.password": "Забули пароль?",
    "admin.success.description": "Натисніть OK і додайте ще один продукт",

    "order.success": "Позицію додано в кошик!",
    "order.error": "Ця позиція вже є в кошику",

    "popap.product.removal": "Видалення продукту",
    "popap.category.removal": "Видалення категорії",
    "popap.want.delete.product": "Ви впевнені, що хочете видалити продукт",
    "popap.want.delete.category": "Ви впевнені, що хочете видалити категорію?",

    "admin.settings.guestLang": "Мова за замовчуванням для гостей",
    "admin.settings.adminLang": "Мова за замовчуванням для адміна",
    "admin.settings.noteGuest": "Ця мова буде встановлена за замовчуванням, коли гості відкриють сторінку.",
    "admin.settings.noteAdmin": "Ця мова буде встановлена за замовчуванням в адмін-панелі.",
    "admin.language": "Мова",
    "admin.settings.logo": "Логотип закладу",
    "admin.settings.logo.text": "Завантажте логотип (PNG/JPG/WEBP/SVG, до 2 МБ). Потім натисніть «Зберегти», це замінить поточний логотип новим.",
    "admin.settings.backtable": "Фонове зображення на екрані вибору столів",
    "admin.settings.backhome": "Фонове зображення головного екрана",
    "admin.settings.backtable.text": "Завантажте фонове зображення (SVG/PNG/JPG/WEBP). Потім натисніть «Зберегти», це замінить поточний фон новим.",
    "admin.settings.language.visitors": "Головна мова для відвідувачів закладу",
    "admin.settings.language.visitors.text": "Ця мова буде основною, коли гості відкривають сторінку",
    "admin.settings.language.admin": "Головна мова вашої адмін-панелі",
    "admin.settings.language.admin.text": "Ця мова буде встановлена за замовчуванням при відкритті адмін-панелі",
    "admin.settings.gallery": "Галерея",
    "admin.settings.social": "Соціальні мережі",
    "admin.settings.number.tables": "Кількість столів",
    "admin.settings.how.many.tables": "Скільки столів у закладі?",
    "admin.settings.tables.test": "Збережіть кількість столів і поверніться на попередню вкладку, щоб налаштувати кожен стіл окремо",
    "admin.settings.upload.panoramic": "Завантажте панорамне зображення залу вашого закладу",
    "admin.settings.table": "Стіл",
    "admin.settings.table.not.found": "Стіл не знайдено",
    "admin.settings.contact.details": "Контактні дані",
    "admin.contacts.company": "Назва компанії",
    "admin.contacts.address": "Адреса",
    "admin.contacts.phone": "Номер телефону",
    "admin.socials.title": "Соціальні мережі",
    "admin.settings.rooms.hint": "Будь ласка, вкажіть кількість залів у закладі",

    "admin.settable.title": "Крок 3. Нумерація столів",
    "admin.settable.text1": "Кожна мітка має номер, розмістіть мітки відповідно до номерів столів.",
    "admin.settable.text2": "Використовуйте перемикач, щоб змінити розмір мітки.",
    "admin.settable.text3": "Збережіть дані поточного столу й натисніть відповідну іконку, щоб перемикатися між столами.",
    "admin.setqr.title": "Ваші QR-коди",
    "admin.setqr.text1": "на цій сторінці зберігаються ваші повідомлення, меню та QR-коди",
    "admin.setqr.text2": "при купівлі тарифу BASIC автоматично створюється QR-код і посилання на вашу субдоменну сторінку, наприклад example.best-place.club",
    "admin.setqr.text3": "ви можете перейти за посиланням, скопіювати його, а також зберегти QR-код як зображення на пристрій",
    "admin.setpanorama.title": "Крок 2. Панорамне зображення",
    "admin.setpanorama.text1": "Додайте панорамне зображення. Рекомендується використовувати легкі файли, наприклад WEBP.",
    "admin.setpanorama.text2": "Якщо зображення успішно завантажено, ви побачите його у попередньому перегляді нижче.",
    "admin.setnumber.title": "Крок 1. Кількість столів",
    "admin.setnumber.text1": "Оберіть кількість столів у вашому закладі",
    "admin.setnumber.text2": "Рекомендується почати налаштування з одного або двох столів, а потім збільшити кількість.",

    "admin.current.logo": "Поточний логотип",
    "admin.add.photo": "тут можна додати файл",
    "admin.add.file": "формати файлів для завантаження: .xlsx, .xls, .csv",
    "admin.add.file.but": "Додати файл",
    "admin.import.format": "Формат колонок: Категорія / Назва / Опис / Ціна",
    "admin.import.follow": "дотримуйтеся вказаного формату колонок і підготуйте файл відповідного формату",
    "admin.import.BeСareful": "Увага: під час імпорту попередні дані будуть втрачені",
    "admin.add.photo.but": "Додати фото",
    "admin.add.photo.set": "Додати фото",

    "admin.wizard.step1": "Оберіть категорію",
    "admin.wizard.step2": "Назва і ціна",
    "admin.wizard.step3": "Опис і фото",
    "admin.wizard.ready": "Готов",
    "admin.wizard.defaultTitle": "Додати продукт",
    "admin.wizard.step1.desc": "Крок 1. Оберіть категорію з існуючих або створіть нову",
    "admin.wizard.step2.desc": "Крок 2. Вкажіть назву продукту потрібними мовами та задайте ціну",
    "admin.wizard.step3.desc": "Крок 3. Напишіть опис продукту, додайте зображення і натисніть зберегти",
    "admin.wizard.step1.desc.short": "Крок 1. Оберіть існуючу або нову категорію",
    "admin.wizard.step2.desc.short": "Крок 2. Додайте назву та ціну продукту",
    "admin.wizard.step3.desc.short": "Крок 3. Опишіть продукт і додайте фото",
    "admin.wizard.tab.existing": "Існуюча",
    "admin.wizard.tab.new": "Нова",
    "admin.wizard.cat.loading": "Завантаження…",
    "admin.wizard.cat.empty": "Категорій ще немає. Перейдіть до «Нова» і створіть першу.",

    "admin.form.categoryKeyDe": "Категорія (KEY/DE)",
    "admin.form.categoryEn": "Категорія (EN)",
    "admin.form.titleMain": "Назва товару",
    "admin.form.descMain": "Опис товару",
    "admin.validation.req": "Введіть назву товару",
    "admin.form.titleDe": "Назва (DE)",
    "admin.form.titleEn": "Назва (EN)",
    "admin.form.nameDe": "Назва (DE)",
    "admin.form.nameEn": "Назва (EN)",
    "admin.form.price": "Ціна",
    "admin.form.descDe": "Опис (DE)",
    "admin.form.descEn": "Опис (EN)",

    "admin.toast.productAdded": "Продукт успішно додано",
    "admin.tooltip.fixFormErrors": "Виправте помилки у формі",

    "admin.validation.firstCharNotDigit": "Перший символ не може бути цифрою.",
    "admin.validation.maxChars": "скороти назву продукту",
    "admin.validation.chooseCategory": "Оберіть категорію.",
    "admin.validation.chooseCategoryFromList": "Оберіть категорію зі списку.",
    "admin.validation.enterCategoryName": "Введіть назву категорії.",
    "admin.validation.enterProductName": "Введіть назву продукту.",
    "admin.validation.priceFormat": "Невірний формат ціни (наприклад, 12.50)",
    "admin.validation.enterDescription": "Введіть опис.",
    "admin.tarif.apply": "застосувати",
    "admin.menu.creating": "Створити меню",
    "admin.choose.template": "Крок 1: Оберіть шаблон",
    "admin.choose.template2": "Крок 2: Перевірте позиції",
    "admin.choose.atyle": "Оберіть стиль меню. Ви можете змінити його пізніше",

    "admin.error.tenantNotFound": "Клієнта для цього субдомену не знайдено.",
    "admin.error.resolveClient": "Не вдалося визначити клієнта.",
    "admin.error.menuLoad": "Не вдалося завантажити меню.",
    "admin.error.saveLang": "Не вдалося зберегти мову.",
    "admin.error.clientNotFound": "Клієнта не знайдено на сервері",
    "admin.error.arrNotFound": "Масив даних для цього клієнта не знайдено",

    "tpl.premium.title": "Преміум",
    "tpl.classic.title": "Класичний",
    "tpl.dark.title": "Темний",
    "tpl.minimal.title": "Мінімальний",
    "tpl.premium.desc": "Топ продажів",
    "tpl.classic.desc": "світлий",
    "tpl.dark.desc": "темний",
    "tpl.minimal.desc": "мінімальний",

    "tp2.position.total": "Зараз у вас:",
    "tp2.position.punkte": "позицій меню",
    "tp2.position.template": "Шаблон",

    "tp3.qr.link": "QR-код і посилання на меню",
    "tp3.step3.title": "Крок 3: Перегляд / Публікація",
    "admin.tp.progres.publication": "Публікація",
    "admin.tp.progres.positionen": "Позиції",

    "tp4.link.copy": "КОПІЮВАТИ",
    "tp4.link.copy.ok": "✓ СКОПІЙОВАНО",

    "admin.tp.publish": "Опублікувати",
    "admin.tp.posting": "публікація ...",

    "admin.import.from.excel": "Імпорт меню з Excel",

    "popap.successful.payment": "Успішна оплата",

    "landing.title": "Цифрові рішення для ресторанів",
    "landing.title.login": "Увійти",
    "landing.text": "Запустіть сайт ресторану за кілька хвилин!",
    "landing.try.now": "спробувати безкоштовно",
    "landing.title.to": "Для кого підходить наш сервіс?",
    "landing.title.answer": "Насамперед він буде корисний власникам закладів, завдання яких — залучати нових клієнтів і утримувати постійних",
    "landing.content.title.first": "Онлайн-меню з QR-кодом",
    "landing.content.first": "Ваші відвідувачі отримують актуальне меню та ціни, просто скануючи QR-код, а спеціальні пропозиції підвищують лояльність до вашого продукту",
    "landing.content.title.second": "Онлайн-бронювання столів",
    "landing.content.second": "Ми пропонуємо вашим гостям візуальне онлайн-бронювання столу з додатковими панорамними зображеннями. За потреби можна переходити між сусідніми зонами",
    "landing.content.title.third": "Атмосферний контент",
    "landing.content.third": "Ваші потенційні відвідувачі зможуть переглядати різний контент: фото інтер’єру, відео приготування топових страв і панорамний вигляд залу.",
    "landing.content.title.four": "Збільшуйте середній чек",
    "landing.content.four": "Пропонуйте гостям банкети, дні народження або спеціальні пропозиції для складних чи щоденних замовлень",
    "landing.request": "Ми скоро зв’яжемося з вами",
    "callback.invalidPhone": "Будь ласка, введіть коректний номер телефону",
    "landing.enter.number": "ВАШ НОМЕР",
    "callback.submitError": "Не вдалося надіслати номер. Будь ласка, спробуйте ще раз",
    "landing.tariff.advance": "Попередження",
    "landing.tariff.advance.desc": "У межах вибраного тарифу ви можете безкоштовно наповнити додаток контентом",
    "landing.tariff.one-time-not-included": "Індивідуальний розрахунок ціни. У правому куті екрана є кнопка зв’язку. Залиште номер, і ми з вами зв’яжемося",
    "landing.tariff.one-time-services": "Разові послуги",
    "landing.tariff.logo-creation": "Створення логотипу",
    "landing.tariff.selling-images": "Створення продаючих зображень продуктів",
    "landing.tariff.panorama-creation": "Створення панорами",

    "demo.video.unsupported": "Ваш браузер не підтримує відео",
    "demo.title.after": "огляд сервісу",
    "demo.title.accent": "короткий",
    "demo.title.before": "Короткий",
    "demo.title.total": "про сервіс",
    "demo.title": "Відеоогляд",

    "landing.free.first": "Онлайн-меню через QR-код доступне, результат за кілька хвилин.",
    "landing.free.second": "Можливість редагувати меню на поточну дату",
    "landing.free.third": "Доступ до конструктора дизайну меню",
    "landing.basic.first": "Повноцінна URL-сторінка з доступом до меню через QR-код",
    "landing.basic.second": "Онлайн-замовлення для ваших відвідувачів",
    "landing.basic.third": "Онлайн-бронювання столів, панорамні фото залу, клікабельні столи та відображення зайнятих і вільних столів у реальному часі",
    "landing.basic.fourth": "Меню з перекладом на любу мову",
    "landing.pro.first": "Функціонал для керування ціновими пропозиціями, створення банерів і маркетингових стратегій",
    "landing.pro.second": "Можливість керувати системою лояльності гостей закладу та впливати на результат відгуків у Google",
    "landing.pro.third": "",
    "landing.title.free": "безкоштовно на 14 днів",
    "landing.registerTitle": "Реєстрація",
    "landing.tariff.selection": "Вибір тарифу",
    "landing.tariff.subdomain": "Реєстрація субдомену",
    "landing.tariff": " / на місяць",
    "landing.your.tariff": "ваш тариф",
    "landing.your.example": "наприклад",
    "landing.Subdomain.selection": "Вибір субдомену",
    "landing.password": "пароль",
    "landing.tariff.free": "БЕЗКОШТОВНО",
    "landing.tariff.free-description": "щоб познайомитися з сервісом",
    "landing.tariff.basic": "БАЗОВИЙ",
    "landing.tariff.basic-description": "базові функції для старту",
    "landing.tariff.pro": "ПРОСУНУТИЙ",
    "landing.tariff.pro-description": "для просунутих користувачів",
    "landing.tariff.selected": "✓ вибрано",
    "landing.legal.text.start": "Я погоджуюся з",
    "footer.legal.terms": "Умовами",
    "landing.legal.text.mid": "та",
    "landing.tariff.optional": "Разові послуги",
    "landing.tariff.one-time-note": "Переглянути тарифи на створення якісних продаючих зображень",
    "landing.tariff.pro-locked-desc": "Цей тариф ще недоступний",
    "landing.tariff.in-development": "У розробці",
    "landing.tariff.free-one-time-desc": "для наповнення вашого меню якісними зображеннями",

    "footer.legal.privacy": "Політика",
    "footer.legal.privacy.and": "конфіденційності",
    "footer.about": "Платформа для ресторанів: меню, бронювання столів, замовлення та адмін-панель.",

    "server.common.unknown": "Невідома помилка.",
    "server.common.serverError": "Внутрішня помилка сервера.",
    "server.common.networkError": "Помилка мережі. Спробуйте ще раз.",
    "server.common.clientIdMissing": "Помилка: clientId відсутній.",

    "server.login.required": "Email і пароль обов’язкові.",
    "server.login.invalidCredentials": "Невірний email або пароль.",
    "server.login.signupIncomplete": "Акаунт ще не активний. Завершіть реєстрацію.",
    "server.login.success": "Вхід успішний!",

    "server.register.required": "Email і пароль обов’язкові.",
    "server.register.emailExistsActive": "Користувач з цим email вже існує. Використайте вхід.",
    "server.register.resume": "Продовжуємо реєстрацію.",
    "server.register.success": "Реєстрація успішна!",

    "server.signupComplete.success": "Активація успішна!",
    "server.signupComplete.error": "Активація не вдалася.",

    "server.subdomain.required": "clientId і subdomain обов’язкові.",
    "server.subdomain.planInvalid": "Невірний тариф. Дозволено: free | basic | pro.",
    "server.subdomain.invalid": "Невірний субдомен (a-z, 0-9, '-', 3–30, без '-' на початку/кінці).",
    "server.subdomain.reserved": "Цей субдомен зарезервований.",
    "server.subdomain.taken": "Цей субдомен уже зайнятий.",
    "server.subdomain.userNotFound": "Користувача не знайдено.",
    "server.subdomain.success": "Субдомен зареєстровано. Перенаправлення…",
    "server.subdomain.error": "Не вдалося зареєструвати субдомен.",

    "landing.loginTitle": "Вхід",
    "landing.btn.login": "Вхід",
    "landing.btn.register": "Реєстрація",
    "landing.btn.enter": "Увійти",
    "landing.loggingIn": "Вхід…",
    "landing.registering": "Реєстрація…",
    "landing.activating": "Активація…",
    "landing.subdomain.registering": "Реєстрація субдомену…",
    "landing.redirecting": "Перенаправлення…",
    "landing.legal.required": "Будь ласка, прийміть Умови та Політику конфіденційності.",

    "landing.subdomain.err.empty": "Будь ласка, введіть субдомен.",
    "landing.subdomain.err.chars": "Лише літери, цифри та '-', 3–30 символів.",
    "landing.subdomain.err.hyphen": "Субдомен не може починатися або закінчуватися символом '-'.",
    "landing.subdomain.err.reserved": "Цей субдомен зарезервований.",

    "admin.menuLanguages.title": "Мови меню",
    "admin.menuLanguages.default": "Мова яку буде бачити відвідувач вашого закладу першою (за замовчанням)",
    "admin.menuLanguages.hint": "Оберіть мови які будуть використовуватися додатково",
    "admin.import.activeLangs": "Активні мови меню",
    "admin.import.sourceLangHint": "Excel буде записаний тільки у вибрану мову. Інші активні мови залишаться порожніми",
    "admin.import.sourceLang": "Вкажіть якою мовою написаний Excel файл",
    "admin.import.mainLang": "головна",

    "booking.date.today": "Сьогодні",
    "booking.date.tomorrow": "Завтра",
    "booking.room": "Зал",

    "front.faq.chat.answer.greeting": "Вітаю! Я допоможу з бронюванням, меню, адресою, графіком роботи та іншими питаннями.",
"front.faq.chat.answer.howAreYou": "Дякую, усе добре! Чим можу допомогти щодо ресторану?",
"front.faq.chat.answer.thanks": "Будь ласка! Звертайтеся, якщо виникнуть ще питання.",
"front.faq.chat.answer.goodbye": "До побачення! Будемо раді вашому візиту.",
"front.faq.chat.answer.whoAreYou": "Я цифровий асистент ресторану. Допомагаю з частими питаннями гостей.",
"front.faq.chat.answer.help": "Я можу допомогти з бронюванням, меню, адресою, телефоном, оплатою, алергенами, доставкою та іншими питаннями.",
"front.faq.chat.answer.recommendation": "Раджу переглянути меню — там ви знайдете актуальні страви та зможете обрати те, що вам підходить.",
"front.faq.chat.answer.compliment": "Дуже дякуємо! Нам приємно це чути.",

"checkout.button.send": "НАДІСЛАТИ",
"checkout.button.sending": "Надсилається ...",
"checkout.button.sent": "Надіслано",
"checkout.title.order": "ЗАМОВЛЕННЯ",
"checkout.phone.title": "Введіть свій номер телефону",
"checkout.phone.label": "Номер телефону",

"footer.workingHours": "Часи роботи",

"admin.offline.title": "Немає інтернет-з’єднання",
"admin.offline.text": "Перевірте підключення до мережі. Після відновлення інтернет-з’єднання роботу можна буде продовжити автоматично.",
"admin.offline.status": "Очікуємо підключення…",


};

  export default uk;